import React from 'react';
import { Button, IconButton, styled, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface ICloseButtonProps {
    onClick: () => void;
}

const StyledButton = styled(Button)(({ theme }) => ({
    zIndex: 10,
    padding: "10px 20px",
    borderRadius: '20px',
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    textTransform: 'none',
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.background.paper,
    }
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    zIndex: 10,
    padding: '10px',
    borderRadius: '50%',
    border: '1px solid',
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default,
    color: theme.palette.primary.main,
    '&:hover': {
        backgroundColor: theme.palette.background.paper,
    }
}));

const CloseButton: React.FC<ICloseButtonProps> = ({ onClick }) => {
    const theme = useTheme();
    const isSmallDevice = useMediaQuery(theme.breakpoints.down('md'));

    return isSmallDevice ? (
        <StyledIconButton onClick={onClick} aria-label="close">
            <CloseIcon />
        </StyledIconButton>
    ) : (
        <StyledButton
            size='large'
            onClick={onClick}
            startIcon={<CloseIcon />}
        >
            Schließen (Close)
        </StyledButton>
    );
};

export default CloseButton;
